<template lang="html">
  <div class="home" v-if="citycode">
    <!-- <div class='white'></div> -->
    <!--<div class="home-top-bar margin-box">

                <div class="home-top-bar-city-trigger" @click="switchCity">
                    <i v-show="!pagelocating" class="icon"></i>
                    {{pagelocating ? '定位中...': cityname}}
                </div>
                 <div class="home-top-bar-search" @click="goSearch"><i class="iconfont icon-fangdajing"></i>搜索您想找的服务 人员 商家</div>
                <template v-for="item in topBarIcons_yuer">
                    <a :href="item.link" class="home-top-bar-yuer" v-if="item" @click="trackClick(200004, `${item.title}`)">
                        <img class="img" :src="item.image"  v-if="item.image">
                        <div class="title" v-if="item.title">{{item.title}}</div>
                    </a>
                </template>
            </div>-->
    <banner
      :posters="banner"
      :citycode="citycode"
      :beforeLoading="beforeLoading"
    >
      <cityTrigger :pagelocating="pagelocating" :cityname="cityname" />
    </banner>
    <!-- 品类 -->
    <categoryList
      :categoryData="categoryData"
      :citycode="citycode"
    ></categoryList>
    <!-- <div class="home-promise">
                <div v-for="item in homeSettings.promise" class='promise-item'>
                    <img class="icon" :src="item.image"  v-if="item.image"></img>
                    <span class="text" v-if="item.text">{{item.text}}</span>
                </div>
            </div> -->
    <!--我的月嫂入口-->
    <div class="chooseYuesao" @click="goYuesao" v-if="showYuesao">
      <span class="leftTip"></span>
      <span class="chooseYuesaocenter">提醒：去查看“我的当前月嫂”详情</span>
      <span class="rightIcon"></span>
    </div>
    <!-- 育儿顾问咨询  -->
    <consultants
      :list="consultantList"
      :citycode="citycode"
      :cityname="cityname"
      v-if="consultantList && consultantList.length > 0"
    />
    <!-- 轮播banner -->
    <jumpBanner
      :posters="jumpBanner"
      :citycode="citycode"
      v-if="jumpBanner.length > 0"
    ></jumpBanner>
    <!-- 拼团秒杀 -->
    <groupSeckill
      :groupSeckillData="groupSeckillData"
      :groupSeckillOther="groupSeckillOther"
    />
    <!-- 身边活动 -->
    <nearbyActivity
      :list="nearbyActivityList"
      v-if="nearbyActivityList && nearbyActivityList.length"
      :citycode="citycode"
      :cityname="cityname"
      lat=""
      lng=""
    />
    <!-- 服务优惠 -->
    <!-- <serviceGroup :groupList="groupList" v-if="groupList && groupList.length"></serviceGroup> -->
    <!-- 育儿大学 -->
    <articles
      :list="articleList"
      v-if="articleList && articleList.length > 0"
      :ids="encodeURIComponent(this.articleIdList.join(','))"
    />
    <!-- 底部资讯 -->
    <broadBottom></broadBottom>
    <div class="newShareEnter" v-if="shareEnter" @click="goNewShare"></div>
  </div>
</template>

<script>
import banner from '@/components/index/banner'
import cityTrigger from '@/components/index/cityTrigger'
import jumpBanner from '@/components/index/jumpBanner'
//import serviceGroup from '@/components/index/serviceGroup'
import broadBottom from '@/components/index/broadBottom'
import categoryList from '@/components/index/categoryList'
//import category from '@/components/index/category'
import yuesao from '@/components/index/yuesaoBox'
//import empty from '@/components/common/empty'
//import storage from '@/plugins/localStorage'
//import groupList from '@/components/index/groupList'
import consultants from '@/components/index/consultants'
import nearbyActivity from '@/components/index/nearbyActivity'
import articles from '@/components/index/articles'
import groupSeckill from '@/components/index/groupSeckill'
//import platform from '@/components/index/platform'

import {
  getLocation,
  getCityCode,
  getCekidCityCode,
  getAPPLatAndLng
} from '@/plugins/location'
import { provinceLevelCity } from '@/plugins/enum'
import jsCookie from 'js-cookie'

export default {
  PAGE_ID: '121011908',
  data() {
    return {
      citycode: '',
      cityname: '',
      lat: '',
      lng: '',
      yuesaoCategory: '10111019',
      homeSettings: {},
      pagelocating: true,
      yuesaoWorkers: [],
      tabIndex: 0,
      tabList: [],
      provinceLevelCity,
      style: {
        height: '1.57rem'
      },
      //groupList: [],
      nearbyActivityList: [], // 附近活动
      consultantList: [], // 育儿顾问列表
      articleList: [], // 育儿知识列表
      advertisements: {}, //广告品类配置
      showYuesao: false,
      shareEnter: false,
      groupSeckillData: {}, //拼团秒杀模块
      groupSeckillOther: [], //拼团秒杀模块其他
      beforeLoading: true,
      categoryData: []
    }
  },
  async created() {
    const { old = '' } = this.$route.query || {}
    if (!old) {
      // 跳转至新版孕产加页面 活动结束可删除
      location.replace('https://life.cekid.com/h5/home')
      return
    }
    this.setCBME()
    this.trackView()
    this.trackBT(121012455)()
    const json = await this.$store.dispatch('getIndexPageSettings')
    const city = (this.$$cookie('city_service') || '').split('_')[0]
    if (city) {
      this.citycode = city
    } else {
      this.citycode = this.$$cookie('citycode') || ''
    }
    if (this.$$isHZWApp()) {
      const { lat, lng } = getAPPLatAndLng()
      if (!this.citycode) {
        this.citycode = '320100'
      }
      this.lat = lat
      this.lng = lng
    } else {
      const { citycode, cityname, lat, lng } = await getLocation()
      if (!this.citycode) {
        this.citycode = citycode
        this.cityname = cityname
      }
      this.lat = lat
      this.lng = lng
    }

    const res = await this.$store.dispatch('getNameById', {
      addressId: this.citycode
    })
    if (res) {
      this.citycode = res.ID
      this.cityname = res.NAME.replace('市', '')
    }
    this.$$cookie.set('groupcity', this.citycode)
    this.pagelocating = false
    this.homeSettings = JSON.parse(this.buildLink(JSON.stringify(json)))
    this.groupSeckillOther = this.homeSettings.groupSeckill
    this.$$loading(false)
    this.$$title(this.homeSettings.pageTitle)
    this.$$share(this.homeSettings.shareInfo || {})
    this.getAdvertisements()
    this.getNearbyActivity()
    this.getWorkers()
    this.getHomeArticleList()
    this.getConsultantList()
    //this.getGroupList()
    this.enterYuesa()
    this.enterNewShare()
    this.getGroupSeckill()
  },
  mounted() {
    this.$$allowRefreshOrShare(true, true)
  },
  computed: {
    // topBarIcons_yuer() {
    //     return this.homeSettings.topBarIcons && this.homeSettings.topBarIcons.yuer
    // },
    banner() {
      return this.advertisements['1_101'] || []
    },
    // categoryData() {
    //     return this.advertisements['2_100'] || []
    // },
    jumpBanner() {
      return this.advertisements['1_102'] || []
    },

    // yuesaoData() {
    //     return this.homeSettings.yuesao || {}
    // },
    // storyList() {
    //     return this.homeSettings.story || []
    // },
    articleIdList() {
      return this.homeSettings.articles || []
    }
    // consultantData() {
    //     return this.homeSettings.consultants || {}
    // },
    // catBannerList() {
    //     let list = this.homeSettings.categoryBanner || []
    //     list = list.filter(item => item.link)
    //     list.length = list.length % 2 ? list.length - 1 : list.length
    //     return list
    // },
    // platformLink() {
    //     const { platformInto = '' } = this.homeSettings
    //     return platformInto
    // }
  },
  methods: {
    async enterYuesa() {
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      if (uid && skey) {
        try {
          const res = await this.$store.dispatch('queryQYWorkerOrderCount', {
            uid
          })
          if (res && +res.code == 1 && res.data > 0) {
            this.showYuesao = true
          }
        } catch (e) {
          this.showYuesao = false
        }
      }
    },
    async enterNewShare() {
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      if (uid && skey) {
        try {
          const res = await this.$store.dispatch('getEmpRefInfo', { uid })
          if (res && +res.code == 0 && res.content && res.content) {
            this.shareEnter =
              res.content.result && res.content.result.staff == 'Y'
                ? true
                : false
          }
        } catch (e) {
          this.shareEnter = false
        }
      }
    },
    goYuesao() {
      location.href = '//life.cekid.com/y/my/yuesao'
    },
    goNewShare() {
      location.href =
        '//life.cekid.com/v/activity/newshare?cmd=share&sharetype=0&refresh=no'
    },
    goSearch() {
      this.trackClick(200002, '首页搜索')
      location.href = '//so.cekid.com/?cmd=kwb2csearch&type=0&keyType=0'
    },
    buildLink(link) {
      return decodeURIComponent(link)
        .replace(/\[cityname\]/g, this.cityname || '')
        .replace(/\[citycode\]/g, this.citycode || '')
    },
    // changeTab(item, index) {
    //     console.log(item)
    //     this.trackClick(200013, item.name)
    //     this.tabIndex = index
    //     this.getHomeArticleList()
    // },
    changeCityToPrivinceCityCode() {
      return getCityCode(this.citycode)
    },
    async getAdvertisements() {
      const city = this.changeCityToPrivinceCityCode()
      try {
        const json = await this.$store.dispatch('getAdvertisements', {
          citycode: city,
          types: '100,101,102'
        })
        this.beforeLoading = false
        this.advertisements = json.data || {}
        this.categoryData = this.advertisements['2_100'] || []
      } catch (e) {
        this.advertisements = {}
      }
    },
    async getNearbyActivity() {
      const cityCode = getCekidCityCode(this.citycode) //不确定到底取哪个城市接口
      const param = {
        ageType: 1, // 年龄段*必填 0:全部 1:孕产妇 2:0-1岁 3:1-3岁 4:3-6岁 5:6岁以上
        cityCode, // 城市编码*必填
        storeCode: '', // 门店编码,
        lat: this.lat, // 纬度,
        lng: this.lng, // 经度,
        page: 1, // 当前页 不填默认1
        pageSize: 10, // 每页记录数 不填默认10
        orderByCond: 3 // 排序规则*必填 1-按价格 2-活动开始时间 3-按距离排序*必填
      }
      const res = await this.$store.dispatch('getNearbyActivity', { param })
      this.nearbyActivityList = res || []
    },
    async getWorkers() {
      const cityId = this.changeCityToPrivinceCityCode()
      const json = await this.$store.dispatch('getWorkersByCondition', {
        pageIndex: 1,
        pageSize: 4,
        cityId,
        districtIds: [],
        categoryIds: [this.yuesaoCategory]
      })
      this.yuesaoWorkers = json || []
    },
    async getHomeArticleList() {
      // const data = this.storyList[this.tabIndex].data || []
      // const filteredData = data.filter(val => (val.type === '1' ? (val.image && val.link) : (val.id !== '')))
      // const ids = filteredData.filter(v => v.id).map(v => v.id).join(',')
      if (this.articleIdList && this.articleIdList.length > 0) {
        const ids = this.articleIdList.join(',')
        const json = await this.$store.dispatch('getHomeArticleList', { ids })
        const arr = json.data
        if (arr && arr.length > 0) {
          this.articleList = arr
        }
        // const arr = filteredData.reduce((prev, next) => {
        //     if (next.type === '0' && json.data) {
        //         next.data = (json.data || []).filter(val => `${val.id}` === `${next.id}`)[0]
        //     }
        //     prev.push(next)
        //     return prev
        // }, []).filter(val => (val.type === '0' && val.data)
        //     || val.type === '1'
        // )
        // const childElements = arr.reduce((prev, next, index) => {
        //     prev[index % 2].push(next)
        //     return prev
        // }, [[], []]).reduce((prev, next) => [...prev, ...next])
        // this.tabList = childElements
        // } else {
        //     this.tabList = []
      }
    },
    // switchCity() {
    //     this.trackClick(200001, '首页城市选择')
    //     location.href = `https://life.cekid.com/h5/city-choose?referer=${encodeURIComponent('https://life.cekid.com/v/home')}`
    // },
    share(city) {
      this.$$share({
        title: this.homeSettings.shareInfo.title,
        desc: this.homeSettings.shareInfo.desc,
        imgUrl: this.homeSettings.shareInfo.image,
        link: `${this.$$hostname('life')}/v/home`
      })
    },
    // async getGroupList() {
    //     const city = this.changeCityToPrivinceCityCode()
    //     const params = {
    //         pageIndex: 1,
    //         pageSize: 5,
    //         cityCode: city,
    //         serviceId: 40
    //     }
    //     this.groupList = await this.$store.dispatch('fetchGroupList', params)
    // },
    async getConsultantList() {
      const cityId = this.changeCityToPrivinceCityCode()
      const lat = this.lat
      const lng = this.lng
      const res =
        (await this.$store.dispatch('getExclusiveConsultantList', {
          cityId,
          lat,
          lng
        })) || []
      // 专属育儿顾问放在第一位
      res.sort(function sortId(a, b) {
        return b.isExclusive - a.isExclusive
      })
      this.consultantList = res
    },
    async getGroupSeckill() {
      const cityCode = this.changeCityToPrivinceCityCode()

      const res = await this.$store.dispatch('getPromTips', {
        cityCode,
        serviceId: 40
      })
      this.groupSeckillData = res
    },
    /**
     * CBME医护渠道需求
     * 根据querystring ->cbme=3055 识别
     * 未登录，将标识写入cookie并跳转至登录页面
     */
    setCBME() {
      let { cbme } = this.$route.query
      if (cbme) {
        jsCookie.set('regSourceId', cbme)
        setTimeout(() => {
          this.$$ensureLogin()
        })
      }
    }
  },
  components: {
    banner,
    //category,
    yuesao,
    // groupList,
    //empty,
    consultants,
    nearbyActivity,
    articles,
    //platform,
    cityTrigger,
    jumpBanner,
    //serviceGroup,
    broadBottom,
    categoryList,
    groupSeckill
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.home {
  position: relative;
  min-height: 100%;
  background: #fff;
  overflow-x: hidden;
  .block-box {
    display: block;
  }
  .margin-box {
    margin: 0 rem(24px);
  }
  .shadow-box {
    background: #ffffff;
    box-shadow: 0 rem(6px) rem(16px) 0 rgba(0, 0, 0, 0.07);
    border-radius: rem(6px);
    margin-bottom: rem(30px);
  }
  .white {
    background: #ffffff;
    .gradien-line {
      height: rem(30px);
      width: 100%;
      background: linear-gradient(#ffffff, #f4f4f4);
    }
  }
  .show-more {
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      height: rem(18px);
      width: rem(10px);
      margin: 0 0 rem(2px) rem(10px);
      background: url('//cmspic-10004025.image.myqcloud.com/a887b720-0205-11ea-98a0-c91677e5da3e_size_9x18')
        no-repeat center center;
      background-size: rem(8px) auto;
    }
  }
  .home-promise {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: rem(14px) 0 0;
    .promise-item {
      margin: 0 rem(30px);
      display: flex;
      align-items: center;
      .icon {
        width: rem(25px);
        height: rem(24px);
        margin-right: rem(16px);
      }
      .text {
        font-size: rem(24px);
        color: #666666;
        margin-top: rem(2px);
      }
    }
  }

  .category-banner {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      margin: rem(24px);
      .left {
        width: rem(170px);
        margin-right: rem(10px);
        .title {
          font-size: rem(28px);
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: rem(10px);
          font-weight: 700;
        }
        .sub-title {
          font-size: rem(22px);
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      img {
        width: rem(120px);
        height: rem(120px);
      }
    }
  }
  .cooupon-banner {
    display: flex;
    align-items: center;
    padding: rem(24px);
    justify-content: space-between;
    .left {
      max-width: rem(500px);
      .title {
        font-size: rem(34px);
        color: #333333;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: rem(12px);
      }
      .desc {
        font-size: rem(26px);
        line-height: rem(35px);
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .right {
      .text {
        font-size: rem(26px);
        color: #666666;
      }
      .iconfont {
        display: inline-block;
        color: #666;
        font-size: rem(24px);
        transform: rotate(-90deg);
      }
    }
  }
  .home-top-bar {
    height: rem(100px);
    display: flex;
    align-items: center;
    background-color: #fff;
    position: relative;
  }

  .home-top-bar-search {
    display: flex;
    align-items: center;
    margin-left: rem(24px);
    width: rem(576px);
    height: rem(60px);
    background: #fff;
    border: rem(1px) solid #ddd;
    border-radius: rem(30px);
    font-size: rem(28px);
    color: #c7c7c7;

    .iconfont {
      padding-left: rem(20px);
      padding-right: rem(10px);
    }
  }
  .home-top-bar-yuer {
    width: rem(66px);
    margin-left: rem(18px);
    text-align: center;
    .img {
      width: rem(40px);
      height: rem(40px);
    }
    .title {
      font-size: rem(20px);
      color: #444444;
    }
  }
  .home-story-list {
    .home-story-tabs {
      display: flex;
      height: rem(88px);
      align-items: center;
      background-color: #fff;
      li {
        flex: 1;
        position: relative;
        text-align: center;
        font-size: rem(28px);
        color: #121212;
      }

      li.current {
        color: #ff397e;
        font-weight: 700;

        &::after {
          content: '';
          position: absolute;
          bottom: rem(-8px);
          left: 50%;
          transform: translate(-50%, 0);
          width: rem(56px);
          height: rem(6px);
          background-image: linear-gradient(-90deg, #ff325b 0%, #fc6398 100%);
          box-shadow: 0 rem(2px) rem(8px) 0 #ff6ea2;
          border-radius: rem(3px);
        }
      }
    }
  }
  .home-story-content {
    width: 100%;
    column-count: 2;
    column-gap: rem(18px);
    transform: translateZ(0);
    background: #f5f5f5;
    padding: 0 rem(18px) rem(40px);

    .home-story-item {
      padding: rem(10px) 0 rem(10px);
      -webkit-column-break-inside: avoid;
      break-inside: avoid;
    }
    .home-story-item-article {
      display: block;
      background: #ffffff;
      // box-shadow: 0 0 rem(15px) rem(4px) rgba(0,0,0,0.05);
      border-radius: rem(6px);
      img {
        width: rem(348px);
        height: rem(324px);
        object-fit: cover;
      }
      .home-story-info {
        padding: rem(24px) rem(20px) rem(30px) rem(20px);

        .title {
          font-size: rem(28px);
          color: #121212;
          font-weight: 700;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }

        p {
          padding-top: rem(20px);
          font-size: rem(22px);
          color: #666666;
          display: flex;
          align-items: center;
        }

        span:first-child {
          flex: 1;
        }
        .iconfont {
          font-size: rem(24px);
          padding-right: rem(8px);
        }
      }
    }
    .home-story-item-pic {
      background: #ffffff;
      // box-shadow: 0 0 rem(15px) rem(4px) rgba(0,0,0,0.05);
      border-radius: rem(6px);
      display: block;
      font-size: 0;

      img {
        width: rem(348px);
        height: rem(320px);
        object-fit: cover;
      }
    }
  }
  .chooseYuesao {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    height: rem(72px);
    margin: 0 rem(20px);
    background: #fff4c7;
    border-radius: rem(12px);
    font-size: rem(28px);
    color: #f96a0e;
    line-height: rem(40px);
    padding: 0 rem(24px);

    .leftTip {
      display: inline-block;
      width: rem(38px);
      height: rem(38px);
      background: url('../../assets/images/icon-tip.png') no-repeat center
        center;
      background-size: rem(38px) auto;
      margin-right: rem(20px);
    }

    .chooseYuesaocenter {
      flex: 1;
      text-align: left;
    }

    .rightIcon {
      display: inline-block;
      width: rem(20px);
      height: rem(20px);
      background: url('../../assets/images/icon-right.png') no-repeat center
        center;
      background-size: rem(20px) auto;
    }
  }

  .newShareEnter {
    position: fixed;
    z-index: 10;
    bottom: rem(24px);
    right: rem(24px);
    width: rem(120px);
    height: rem(120px);
    background: url('../../assets/images/newShare/icon-shareEnter.png')
      no-repeat center center;
    background-size: rem(120px) rem(120px);
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';
.bottom-banner.poster {
  height: rem(184px) !important;
}
</style>
